import type {ListRolesSearchInput} from "./list-roles.schema";
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {listRolesQueryOptions} from "./list-roles.query-options";

export function useListRoles(input: ListRolesSearchInput) {
  return useQuery({...listRolesQueryOptions(input), placeholderData: keepPreviousData});
}
